import { SxProps, Theme } from "@mui/material/styles";

export const homeContainer: SxProps<Theme> = {
    width: "100%",
    minHeight: "100dvh",
    display: "flex",
    flexDirection: "column",
    position: "relative",
};

export const welcomeSection: SxProps<Theme> = {
    maxWidth: "1000px",
    margin: "0 auto",
    pt: { xs: 3, sm: 4, md: 5 },
    px: { xs: 3, sm: 5, md: 7.5 },
    textAlign: "center",
};

export const answersGrid: SxProps<Theme> = {
    flexGrow: 1,
    padding: {
        xs: 2,
        sm: 3,
        md: 4,
    },
    gap: {
        xs: 4,
        sm: 6,
        md: 8,
    },
    mb: 10,
    justifyContent: "center",
    alignItems: "center",
};

export const grid: SxProps<Theme> = {
    xs: 6,
    sm: 6,
    md: 6,
    display: "flex",
};

export const card: SxProps<Theme> = {
    textDecoration: "none",
    width: "100%",
    height: {
        xs: "40dvh",
        sm: "45dvh",
        md: "50dvh",
    },
    display: "flex",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    borderRadius: 2,
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
        transform: "scale(1.02)",
        boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
    },
};

export const cardMedia: SxProps<Theme> = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center",
    display: "block",
};

export const cardContent: SxProps<Theme> = {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    padding: 2,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    minHeight: "80px",
};

export const typography: SxProps<Theme> = (theme: Theme) => ({
    color: theme.palette.common.white,
    fontFamily: "HsvSlab",
    fontWeight: "bold",
    fontSize: {
        xs: "1.1rem",
        sm: "1.3rem",
        md: "1.5rem",
    },
});

export const logoImage: SxProps<Theme> = {
    height: {
        xs: "40px",
        sm: "50px",
        md: "60px",
    },
    width: "auto",
    objectFit: "contain",
};

export const arrowIcon: SxProps<Theme> = (theme: Theme) => ({
    position: "absolute",
    top: 16,
    right: 16,
    width: {
        xs: "36px",
        sm: "40px",
        md: "44px",
    },
    height: {
        xs: "36px",
        sm: "40px",
        md: "44px",
    },
    borderRadius: "50%",
    backgroundColor: theme.palette.common.black,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
});

export const arrowIconSvg: SxProps<Theme> = (theme: Theme) => ({
    color: theme.palette.common.white,
    fontSize: {
        xs: "20px",
        sm: "22px",
        md: "24px",
    },
});
